import { ApplicationTypes, Hole54, attachComponent, featureLabels } from 'metalworks-domain'

import { detailComponent, entityHeaderComponent, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { GenericDistancePropertyPage } from '../ui/property-pages/GenericDistancePropertyPage'
import { createInnerRadiusDimensionIndicatorComponent } from './common'

export const hole54Components = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('Hole54')
    .attach(() => {
      return {
        title: featureLabels[Hole54.type],
        subtitle: 'Fixed diameter',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/circular-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('Hole54')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <GenericDistancePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('Hole54')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  createInnerRadiusDimensionIndicatorComponent('Hole54'),
]
